import moment from "moment-timezone";

import { DISPLAY_DATE_FORMAT } from "@/v1/constants";

interface DeclarationDownloadNameParams {
  firstName?: string;
  lastName?: string;
  declarationName: string;
  taxYear: number;
  creationDate: Date;
}

export const getDeclarationDownloadName = ({
  firstName,
  lastName,
  declarationName,
  taxYear,
  creationDate,
}: DeclarationDownloadNameParams) => {
  const creationDateFormat = moment(creationDate).format(DISPLAY_DATE_FORMAT);
  return `${declarationName}, ${lastName}, ${firstName}, ${taxYear} - ${creationDateFormat}.pdf`;
};
